import React from "react";

const TermsAndConditions = () => {
  const terms = [
    "By using this platform, users agree to connect their verified Google Business Listing for the purpose of syncing and managing data.",
    "The service allows users to view and manage their business details and public reviews directly from the platform interface.",
    "Users must ensure that the information provided during account setup and connection is accurate and up-to-date.",
    "The platform does not guarantee the visibility, performance, or ranking of the connected business listing on external platforms.",
    "The review flagging feature is intended solely for legitimate concerns such as spam, abuse, or inaccurate content.",
    "Each flag submission is reviewed by an admin, who reserves the right to approve or reject it based on established criteria.",
    "Abuse of the flagging system, including repeated false flags or harassment, will result in account suspension.",
    "Access to the platform may be suspended or terminated at any time in cases of policy violations or suspicious activity.",
    "Users are responsible for safeguarding their login credentials and for all actions performed under their account.",
    "Changes to the terms may be made at any time. Continued use of the platform constitutes acceptance of any updated terms.",
  ];

  return (
    <section className="min-h-screen bg-gray-50 py-20 px-6 md:px-24">
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-xl p-10 animate-fade-in space-y-6">
        <h1 className="h1-mb h1-md h1-lg h1-2xl">Terms & Conditions</h1>
        <ul className="list-decimal list-inside space-y-4 text-gray-700 text-base">
          {terms.map((term, index) => (
            <li key={index}>{term}</li>
          ))}
        </ul>
        <p className="text-sm text-gray-500 text-center italic pt-4">
          Last updated: July 2025
        </p>
      </div>
    </section>
  );
};

export default TermsAndConditions;
